import { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../config';

const useUpdateQuantity = (fetchCart) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleUpdateQuantity = async (slug, quantity) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const authToken = localStorage.getItem('authToken');
      const anonymousUserId = localStorage.getItem('anonymousUserID');

      const requestData = { slug, quantity };
      const headers = { 'Content-Type': 'application/json' };

      if (authToken) {
        headers['Authorization'] = `Token ${authToken}`;
      } else if (anonymousUserId) {
        requestData.anonymous_user_id = anonymousUserId;
      }

      const response = await axios.post(
        `${BASE_URL}/api/update-quantity/`,
        requestData,
        { headers }
      );

      if (response.status === 200) {
        setSuccess(true);
        fetchCart();
      } else {
        throw new Error('Unexpected response from the server.');
      }
    } catch (err) {
      console.error('Error updating quantity:', err);

      const backendMessage =
        err.response?.data?.error || 'Failed to update quantity. Please try again.';

      setError(backendMessage);
    } finally {
      setLoading(false);
    }
  };

  return { handleUpdateQuantity, loading, error, success };
};

export default useUpdateQuantity;
